// components/HeroSection/slider/Slider.jsx
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
// import slider1 from "../../../../assets/windTree/images/heroBanner/slider1.webp";
// import slider2 from "../../../../assets/windTree/images/heroBanner/slider2.webp";
// import slider3 from "../../../../assets/windTree/images/heroBanner/slider3.webp";
// import img1 from "../../../../assets/windTree/images/heroBanner/img1.webp";
import img2 from "../../../../assets/windTree/images/heroBanner/img2.webp";
import img3 from "../../../../assets/windTree/images/heroBanner/img3.webp";
import img4 from "../../../../assets/windTree/images/heroBanner/img4.webp";
import img5 from "../../../../assets/windTree/products/zebraBlinds.webp";
const Sliders = ({ autoPlay = false, interval = 5000, className = '' }) => {

    const [typedText, setTypedText] = useState('');
    // Slides array with high-quality images
    const slides = [
        // {
        //     id: 1,
        //     image: img1,
        //     alt: "Luxury living room with elegant vertical blinds",
        //     caption: "Panel Blinds"
        // },
        {
            id: 2,
            image: img2,
            alt: "Modern office with automated window shades",
            caption: "Triple Window Blinds"
        },
        {
            id: 3,
            image: img3,
            alt: "Minimalist bedroom with blackout curtains",
            caption: "Wooden Blinds"
        },
        {
            id: 4,
            image: img4,
            alt: "image 4",
            caption: "Aluminium Venetian Blinds"
        },
        {
            id: 5,
            image: img5,
            alt: "image 5",
            caption: "Zebra Blinds"
        },
        // {
        //     id: 4,
        //     image: "https://i.postimg.cc/26grJy1L/img4.jpg", alt: "Spacious living room with floor-to-ceiling windows",
        //     caption: "Grand Living Room with Custom Treatments"
        // },
        // {
        //     id: 5,
        //     image: "https://i.postimg.cc/2ypNGttk/img5.jpg", alt: "Elegant dining room with sheer curtains",
        //     caption: "Sophisticated Dining with Sheer Elegance"
        // },
        // {
        //     id: 6,
        //     image: "https://i.postimg.cc/tRdM87Zr/img8.jpg", alt: "Modern home office with roller blinds",
        //     caption: "Productive Workspace with Light Control"
        // }
    ];

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [hoverSpeed, setHoverSpeed] = useState(false);
    const timerRef = useRef(null);
    const hoverTimerRef = useRef(null);

    // Preload images
    useEffect(() => {
        slides.forEach((slide) => {
            const img = new Image();
            img.src = slide.image;
        });
    }, []);

    const goToPrevious = useCallback(() => {
        if (isTransitioning) return;
        setIsTransitioning(true);
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? slides.length - 1 : prevIndex - 1
        );
        setTimeout(() => setIsTransitioning(false), 900);
    }, [isTransitioning, slides.length]);

    const goToNext = useCallback(() => {
        if (isTransitioning) return;
        setIsTransitioning(true);
        setCurrentIndex((prevIndex) =>
            prevIndex === slides.length - 1 ? 0 : prevIndex + 1
        );
        setTimeout(() => setIsTransitioning(false), 900);
    }, [isTransitioning, slides.length]);

    const goToSlide = useCallback((index) => {
        if (isTransitioning || index === currentIndex) return;
        setIsTransitioning(true);
        setCurrentIndex(index);
        setTimeout(() => setIsTransitioning(false), 900);
    }, [isTransitioning, currentIndex]);

    // Clear all timers
    const clearAllTimers = useCallback(() => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
        if (hoverTimerRef.current) {
            clearInterval(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
    }, []);

    // Handle autoplay with speed control
    const startAutoplay = useCallback((speed = interval) => {
        clearAllTimers();
        if (autoPlay) {
            timerRef.current = setInterval(goToNext, speed);
        }
    }, [autoPlay, interval, goToNext, clearAllTimers]);

    // Mouse enter - increase speed (slide every 1 second)
    const handleMouseEnter = useCallback(() => {
        clearAllTimers();
        setHoverSpeed(true);
        // Start fast sliding (every 1 second)
        hoverTimerRef.current = setInterval(goToNext, 1000);
    }, [clearAllTimers, goToNext]);

    // Mouse leave - return to normal speed
    const handleMouseLeave = useCallback(() => {
        setHoverSpeed(false);
        clearAllTimers();
        if (autoPlay) {
            timerRef.current = setInterval(goToNext, interval);
        }
    }, [autoPlay, interval, goToNext, clearAllTimers]);

    // Initial autoplay setup
    useEffect(() => {
        startAutoplay(interval);
        return clearAllTimers;
    }, [interval, startAutoplay, clearAllTimers]);

    useEffect(() => {
        const text = slides[currentIndex]?.caption || '';
        setTypedText('');

        let index = 0;

        const typingTimer = setInterval(() => {
            if(index < text.length) {
                setTypedText(text.slice(0, index + 1));
                index++;
            } else {
                clearInterval(typingTimer);
            }
        }, 80);
        return () => clearInterval(typingTimer);
    },[currentIndex]);

    return (
        <div className={`relative w-full ${className}`}>
            <style>{`
                @keyframes blindOpen {
                    0% {
                        transform: scaleY(1);
                    }

                    100% {
                        transform: scaleY(0);
                    }
                }

                .blind-strip {
                    background: rgba(0, 0, 0, 0.95);
                    transform-origin: top;
                    animation: blindOpen 0.8s ease-in-out forwards;
                }

                @keyframes blinkCursor {
                    0%, 50% {
                        opacity: 1;
                    }

                    51%, 100% {
                        opacity: 0;
                    }
                }

                .typing-cursor {
                    display: inline-block;
                    margin-left: 3px;
                    animation: blinkCursor 0.8s infinite;
                    font-weight: 400;
                }
            `}</style>
            <div
                className="relative w-full overflow-hidden rounded-b-2xl top-[75px]"
                style={{ height: '100%' }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <div className="relative w-full h-full">
               {slides.map((slide, index) => {
    if (index !== currentIndex) return null;

    return (
        <div
            key={`${slide.id}-${currentIndex}`}
            className="absolute inset-0 z-10 overflow-hidden"
        >
            {/* Image */}
            <img
                src={slide.image}
                alt={slide.alt}
                className="absolute inset-0 w-full h-full object-cover"
                loading={index === 0 ? "eager" : "lazy"}
            />

            {/* Blinds */}
            <div className="absolute inset-0 z-10 pointer-events-none">
                {[...Array(12)].map((_, i) => (
                    <div
                        key={i}
                        className="blind-strip absolute left-0 w-full"
                        style={{
                            top: `${(i * 100) / 12}%`,
                            height: `${100 / 12}%`,
                            animationDelay: `${i * 0.06}s`,
                        }}
                    />
                ))}
            </div>
        </div>
    );
})}
                    {/* Gradient Overlay */}
                    <div className="absolute  inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none z-5"></div>

                    {/* Caption Overlay - Adjusted for mobile */}
                    {slides[currentIndex]?.caption && (
                        <div className="absolute text-center bottom-[90px] !right-0  bg-gradient-to-t from-black/90 via-black/50 to-transparent p-4 sm:p-6 md:p-8 transition-opacity duration-300 z-20">
                           <p className="text-white font-bold text-xl sm:text-base md:text-lg lg:text-4xl tracking-wide">
    {typedText}
    {/* <span className="typing-cursor">|</span> */}
</p>
                        </div>
                    )}

                    {/* Navigation Arrows - Hidden on mobile, visible on tablet/desktop */}
                    <button
                        onClick={goToPrevious}
                        disabled={isTransitioning}
                        className="hidden sm:block absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 md:p-3 rounded-full transition-all duration-200 hover:scale-110 z-20 disabled:opacity-50 disabled:cursor-not-allowed"
                        aria-label="Previous image"
                    >
                        <ChevronLeft className="w-4 h-4 md:w-5 md:h-5 text-gray-800" />
                    </button>
                    <button
                        onClick={goToNext}
                        disabled={isTransitioning}
                        className="hidden sm:block absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 md:p-3 rounded-full transition-all duration-200 hover:scale-110 z-20 disabled:opacity-50 disabled:cursor-not-allowed"
                        aria-label="Next image"
                    >
                        <ChevronRight className="w-4 h-4 md:w-5 md:h-5 text-gray-800" />
                    </button>

                    {/* Slide Counter - Adjusted positioning */}
                    {/* <div className="absolute top-2 right-2 sm:top-4 sm:right-4 bg-black/70 backdrop-blur-sm text-white px-2 py-1 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-medium z-20 shadow-lg border border-white/20">
                        {currentIndex + 1} / {slides.length}
                    </div> */}

                    {/* Dots Navigation - Adjusted for mobile */}
                    <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2 sm:space-x-3 z-20">
                        {slides.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => goToSlide(index)}
                                disabled={isTransitioning}
                                className={`transition-all duration-200 rounded-full ${index === currentIndex
                                    ? 'w-4 sm:w-8 h-1.5 sm:h-2 bg-[#0d5f07]'
                                    : 'w-2  sm:w-2 h-1.5 sm:h-2 bg-white/70 hover:bg-white'
                                    }`}
                                aria-label={`Go to slide ${index + 1}`}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sliders;